/** @flow */

import {
  GetDataSecuritySettings,
  GetDataSecuritySettingsSuccess,
  GetDataSecuritySettingsError,
  UpdateDataSecuritySettings,
  UpdateDataSecuritySettingsError,
  UpdateDataSecuritySettingsSuccess,
  GetEmployeeSecuritySchemaSuccess,
  GetEmployeeSecuritySchemaError,
  GetEmployeeSecuritySchema,
} from "@modules/service/constants/actions";
import * as dataSecurityReducers from "./reducers";
import initialState from "./state";
import type { DataSecurityState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: DataSecurityState = initialState, action: Object): DataSecurityState => {
  const act = {
    [GetDataSecuritySettings]: dataSecurityReducers.setLoading,
    [GetDataSecuritySettingsSuccess]: dataSecurityReducers.onGetSecuritySettingsSuccess,
    [GetDataSecuritySettingsError]: dataSecurityReducers.onGetSecuritySettingsError,
    [UpdateDataSecuritySettings]: dataSecurityReducers.setLoading,
    [UpdateDataSecuritySettingsSuccess]: dataSecurityReducers.onUpdateSecuritySettingsError,
    [UpdateDataSecuritySettingsError]: dataSecurityReducers.onUpdateSecuritySettingsError,
    [GetEmployeeSecuritySchemaSuccess]: dataSecurityReducers.onGetEmployeeSecuritySchemaSuccess,
    [GetEmployeeSecuritySchemaError]: dataSecurityReducers.onGetEmployeeSecuritySchemaError,
    [GetEmployeeSecuritySchema]: dataSecurityReducers.setLoading,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
